import PATH from "constants/path";
import * as moment from "moment";
import { SERVICE, PREFERENC, DATE_FORMAT } from "constants/global";

/**
 * clear data in local storage
 */
const clearLocalStorage = () => {
  localStorage.clear();
};

/**
 * return boolean
 * check data in local storage
 */
const isAuthenticated = () => {
  try {
    return !!JSON.parse(localStorage.getItem("AUTH"));
  } catch (error) {
    clearLocalStorage();
    return false;
  }
};

/**
 * save data to local storage
 */
const saveTokenInStorage = (data) => {
  localStorage.setItem("AUTH", JSON.stringify(data));
};

const getInfoResponse = (data) => {
  if (
    data.hasOwnProperty("userIdData") &&
    data.hasOwnProperty("userNameData") &&
    data.hasOwnProperty("userTotalPointData")
  ) {
    return {
      id: data?.userIdData,
      name: data?.userNameData,
      point: data?.userTotalPointData,
    };
  } else {
    return null;
  }
};

const saveInfoLocal = (data) => {
  const userBefore = JSON.parse(localStorage.getItem("USER"));

  if (
    !userBefore ||
    (data.hasOwnProperty("userIdData") &&
      data.hasOwnProperty("userNameData") &&
      data.hasOwnProperty("userTotalPointData") &&
      (userBefore?.id !== data?.userIdData ||
        userBefore?.point !== data?.userTotalPointData))
  ) {
    localStorage.setItem(
      "USER",
      JSON.stringify({
        id: data?.userIdData,
        name: data?.userNameData,
        point: data?.userTotalPointData,
      })
    );
  }
};

/**
 * return object (token)
 */
const getTokenLocal = () => {
  try {
    return JSON.parse(localStorage.getItem("AUTH"));
  } catch (error) {
    clearLocalStorage();
    return null;
  }
};

/**
 * return object (user)
 */
const getUserLocal = () => {
  try {
    const user = JSON.parse(localStorage.getItem("USER"));
    if (
      user &&
      user.hasOwnProperty("id") &&
      user.hasOwnProperty("name") &&
      user.hasOwnProperty("point")
    ) {
      return user;
    } else {
      return null;
    }
  } catch (error) {
    clearLocalStorage();
    return null;
  }
};

/**
 * return string
 * (URL COMMON site)
 */
const returnCommom = () => {
  window.location = `${
    PATH.COMMON
  }?service=${SERVICE}&redirect_uri=${encodeURIComponent(
    window.location.href.split("#")[0]
  )}`;
};

/**
 * return string
 * share TOKEN , USER_INFO for other fansite
 */
const getPathSerive = () => {
  const token = getTokenLocal();

  return token
    ? `?token=${token.access_token}&expires_date=${encodeURIComponent(
        token.expires_date
      )}`
    : "";
};

/**
 * scrool to element
 * @param element string
 * @param yOffset int
 */
const scroolElement = (element, yOffset) => {
  const el = document.querySelector(element);
  const y = el.getBoundingClientRect().top + window.pageYOffset - yOffset;
  window.scrollTo({ top: y, behavior: "smooth" });
};

/**
 * return timestamp
 * @param Date string date or null
 */
const getTimestamp = (d, format = DATE_FORMAT.DATE) => {
  const dateObj = getDateObj(d, format);
  return dateObj ? dateObj.getTime() : null;
};

/**
 * return date object from date string
 * @param Date string
 * @param format string
 */
const getDateObj = (date, format) => {
  if (format) {
    const d = date || new Date();
    return moment(d, format).toDate();
  }
  return new Date();
};

/**
 * return string
 * Preference name
 */
const mapPreference = (pref_code) => {
  if (pref_code >= 0 && pref_code <= 47) {
    return PREFERENC[pref_code];
  } else {
    return "ー";
  }
};

/**
 * return string
 * ex: 000-0000-0000
 * @param number string
 */
 const formatPhoneNumber = (phoneNumberString) => {
  var match =
    String(phoneNumberString).match(/^(\d{3})(\d{4})(\d{4})$/) ||
    String(phoneNumberString).match(/^(\d{3})(\d{4})(\d{3})$/);
  if (match) {
    return match[1] + "-" + match[2] + "-" + match[3];
  }
  return phoneNumberString;
};

/**
 * return string
 * ex: 1,000,000
 * @param number string
 */
const formatNumber = (number, limit = 8) => {
  if (number !== null) {
    const formatNumber = number.toLocaleString("ja-JP");
    return number.toString().length > limit
      ? formatNumber.slice(0, limit + 1) + ".."
      : formatNumber;
  }
};

/**
 * return date
 * ex: 2022年1月1日
 * @param number string
 */
const formatJapanDate = (date) => {
  if (!date) return "";
  const d = new Date(date.replace(/-/g, "/"));
  return (
    d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日"
  );
};

/**
 * return html
 * @param listTitle array
 */
const getTitleDecoration = (listTitle) => {
  return listTitle ? listTitle.reduce((item, current) => current + item) : null;
};

/**
 * return string
 * @param number int
 */
const formatTwoCharacter = (number) => {
  return number < 10 ? "0" + number : number;
};

/**
 * return date
 * ex: 2022/01/01
 * @param date date
 */
const formatSimpleDate = (date) => {
  if (!date) return "";
  const d = new Date(date.replace(/-/g, "/"));
  return (
    d.getFullYear() +
    "/" +
    formatTwoCharacter(d.getMonth() + 1) +
    "/" +
    formatTwoCharacter(d.getDate())
  );
};

/**
 * return string
 * ex: 月
 * @param date date
 */
const getDayOfDate = (date) => {
  if (!date) return "";
  return new Date(date.replace(/-/g, "/")).toLocaleDateString("ja-JP", {
    weekday: "short",
  });
};

/**
 * set cookie
 * @param {*} name 
 * @param {*} value 
 */
const setCookie = (name, value) => {
  document.cookie = `${name}=${value};path=/`;
};

/**
 * get cookie
 * @param {*} name 
 * @returns 
 */
function getCookie(name) {
  const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return cookieValue ? cookieValue.pop() : '';
}

export {
  clearLocalStorage,
  isAuthenticated,
  saveTokenInStorage,
  getTimestamp,
  getDateObj,
  mapPreference,
  formatJapanDate,
  formatSimpleDate,
  formatNumber,
  getTitleDecoration,
  getTokenLocal,
  returnCommom,
  getPathSerive,
  getDayOfDate,
  formatTwoCharacter,
  scroolElement,
  getInfoResponse,
  saveInfoLocal,
  getUserLocal,
  setCookie,
  getCookie,
  formatPhoneNumber,
};
